import type { FC } from 'react';

interface NzFlagProps {
    width?: string;
    height?: string;
}

const NzFlag: FC<NzFlagProps> = ({ width = '40', height = '30' }) => (
    <svg
        aria-hidden="true"
        focusable="false"
        width={width}
        height={height}
        viewBox="0 0 40 30"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="40" height="30" rx="4" fill="#00247D" />
        <path d="M0 0H2L20 12.75V15H18L0 2.25V0ZM20 0H18L0 12.75V15H2L20 2.25V0Z" fill="#fff" />
        <path d="M0 0H1L20 14.25V15H19L0 .75V0ZM20 0H19L0 14.25V15H1L20 .75V0Z" fill="#CC142B" />
        <path d="M0 5.5H20V9.5H0V5.5ZM8 0H12V15H8V0Z" fill="#fff" />
        <path d="M0 6H20V9H0V6ZM8.5 0H11.5V15H8.5V0Z" fill="#CC142B" />
        <g fill="#CC142B" stroke="#fff" strokeWidth=".45">
            <path d="M30 5.2l.7 1.5 1.6.2-1.2 1.1.3 1.6-1.4-.8-1.4.8.3-1.6-1.2-1.1 1.6-.2.7-1.5Z" />
            <path d="M35 12l.7 1.5 1.6.2-1.2 1.1.3 1.6-1.4-.8-1.4.8.3-1.6-1.2-1.1 1.6-.2L35 12Z" />
            <path d="M28.5 16.5l.7 1.5 1.6.2-1.2 1.1.3 1.6-1.4-.8-1.4.8.3-1.6-1.2-1.1 1.6-.2.7-1.5Z" />
            <path d="M33.5 22l.7 1.5 1.6.2-1.2 1.1.3 1.6-1.4-.8-1.4.8.3-1.6-1.2-1.1 1.6-.2.7-1.5Z" />
        </g>
    </svg>
);

export default NzFlag;
